<template>
  <div>
    {{ statusKey | CoverageStatus | t }}
  </div>
</template>

<script>
export default {
  props: ["rowData"],
  computed: {
    statusKey() {
      return this.rowData?.statusKey;
    },
  },
};
</script>
